<template>
  <div class="course-card jcb csp" :class="flex" :style="{width: width + 'px', height: height + 'px'}" @click="$emit('detail', innerItem)">
    <div class="img-box por zi1 ovh" :style="{width: imageWidth + 'px', height: imageHeight + 'px'}">
      <img :src="innerItem[imgKey]" alt="" class="img-bg w100 h100 vam" v-df-base>
      <div class="poa zi1 t0 l0 w100 flex jcb" v-show="innerItem.left_ico || innerItem.right_ico">
        <img :src="innerItem.left_ico" alt="" class="tag-left vat">
        <img :src="innerItem.right_ico" alt="" class="tag-right vat" v-show="!vipType">
      </div>
      <div class="poa zi1 r0 t0 vip-type-tip" v-if="vipType">
        <label-tip :label-type="vipType" radius-type="9" :text="labelText"></label-tip>
      </div>
      <div class="audio-play poa l0 w100 h100 lh1 b0" v-show="isShowAudio">
        <img src="../../assets/images/card/icon_music.png" alt="" class="audio-ico vam poa">
        <div class="poa t0 l0 w100 h100 audio-bg hover-show">
          <img v-if="isAudioPlay" src="../../assets/images/card/icon_pause.png" alt="" class="audio-imgs poa" @click.stop="$emit('pause', innerItem)">
          <img v-else src="../../assets/images/card/icon_play2.png" alt="" class="audio-imgs poa" @click.stop="$emit('play', innerItem)">
        </div>
      </div>
      <div class="mask-box poa w100 h100 t0 hover-show" v-show="showMask">
        <img src="../../assets/images/card/icon_play.png" alt="" class="icon_play poa" />
      </div>
      <slot :item="innerItem" name="image"></slot>
    </div>
    <div class="detail-box lh1 bsb flex-1">
      <template v-for="(prop, i) in showPropsArr">
        <div :key="i" class="prop-box">
          <div v-if="prop === 'name'" :class="prop" class="prop w100 set-line-height">
            <df-tip :type="innerItem.type" :content="filterTest(prop)" :row="row"></df-tip>
          </div>
          <p v-else-if="prop === 'buy_num'" class="fs12 color_999 course-buy" :class="{'dn':!innerItem.buy_num}">
            {{innerItem.buy_num}}人购买</p>
          <p v-else-if="prop === 'hits'" class="fs12 color_999 course-hits" :class="{'dn':!innerItem.hits}">
            {{innerItem.hits | filterCount}}人在学</p>
          <div v-else-if="prop === 'price' " class="flex aic">
            <template v-if="isPayCourse">
              <p class="fs18 course-price">
                ￥{{userInfo.is_web_vip ? innerItem.vip_price : innerItem.price}}
                <s class="fs14 pl5 color_666" v-show="innerItem.is_activity">￥{{userInfo.is_web_vip ? innerItem.original_vip_price : innerItem.original_price}}</s>
              </p>
              <div class="course-activity pl5 fs12" v-if="innerItem.is_activity">
                <p class="discount" v-if="innerItem.discount"><span class="discount-time dib">限时</span><span class="discount-count dib">{{innerItem.discount}}折</span></p>
                <p class="no-discount tac" v-else><span class="pl5">限时特价</span></p>
              </div>
            </template>
          </div>
          <slot v-else-if="prop.indexOf('slot_') === 0" :name="prop" :item="innerItem"></slot>
          <div v-else class="prop w100 set-line-height" :class="prop">
            <df-tip :content="filterTest(prop)" :row="row"></df-tip>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "card",
  filters: {
    filterTitle (text) {
      text = text ? text.split(/[:：]/) : '';
      return text[1] || text[0];
    },
    filterCount (num) {
      if (num > 10000) {
        return (num / 10000).toFixed(2) + '万'
      } else {
        return num;
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'currAudio']),
    isShowAudio () {
      let { type, element_content: content, format_id } = this.innerItem;
      content = content || this.innerItem;
      return this.hiddenAudio !== true && type === 1 && (format_id || content.format_id) === 2;
    },
    vipType () {
      let { type, element_content: content } = this.innerItem;
      let { is_web_vip } = this.userInfo;
      content = content || this.innerItem;
      let label = this.isCustomLabel ? this.getLabelType() : '';
      let label_type = '';
      if(type === 1){
        if(content.is_pay === 1){
          label_type = content.type === 1 ? is_web_vip ? 'false' : ['','free'][type] : 'false';
        }else{
          label_type =  content.type === 1 && is_web_vip ? 'false' : ['', 'free', 'vip', 'pay'][content.type];
        }
      }else if(type === 2){
        label_type = 'zt';
      }
      return this.labelType || label || label_type;
      // return this.labelType || label || (type === 1 ? content.is_pay === 1 || (content.type === 1 && is_web_vip ? 'false' : ['', 'free', 'vip', 'pay'])[content.type] :
      //   type === 2 ? 'zt' : '');
    },
    innerItem () {
      let config = Object.keys(this.item).reduce((r, c) => ({ ...r, [c]: c }), {});
      return this.Tools.changeObject(this.item, Object.assign(config, this.changeProp));
    },
    showPropsArr () {
			// 需要显示的字段 多字段用 逗号,间隔
      return (typeof this.showProps === 'string' ? this.showProps.split(',') : [...this.showProps]).map(s => (s + '').trim());
    },
		filterList(){
			// 需要过滤的字段 多字段用 逗号,间隔
			if(this.filter === ''|| !this.filter){
				this.filter = this.showProps;
			}
			return (typeof this.filter === 'string' ? this.filter.split(',') : [...this.filter]).map(s => (s + '').trim());
		},
    filterTest () {
      return (prop) => {
				let isfilter = this.filterList.includes(prop) //查找过滤列表，是否过滤 冒号，只显示冒号后面内容
        return isfilter? this.$options.filters['filterTitle'](this.innerItem[prop]) : this.innerItem[prop];
      }
    },
    isAudioPlay () {
      let { currAudio, innerItem } = this;
      let audio = this.currAudio ? this.GetAppAudio() : null;
      return audio && audio.playing && currAudio && currAudio.isPlay && currAudio.cid === (innerItem.element_content && innerItem.element_content.id);
    },
    isPayCourse(){
      let { type, element_content: content } = this.innerItem;
      let courseType = (content&&content.type) ? content.type : type;
      return +courseType === 3;
    }
  },
  data () {
    return {};
  },
  props: {
    // 布局类型
    flex: {
      type: String,
      default: 'flex-col',
    },
    // 显示的课程/专题
    item: {
      type: Object,
      required: true,
    },
    // 隐藏音频标识
    hiddenAudio: {
      type: Boolean,
      default: false,
    },
    // 图片宽
    imageWidth: {
      type: String | Number,
      default: ''
    },
    // 图片高
    imageHeight: {
      type: String | Number,
      default: ''
    },
    // 元素宽
    width: {
      type: String | Number,
      default: ''
    },
    // 元素高
    height: {
      type: String | Number,
      default: ''
    },
    // 显示的详情字段多个用','分隔
    //   __count: 课时计数
    //   __pay: 付费信息
    //   __discount: 优惠标签
    showProps: {
      type: String | Array,
      default: 'name'
    },
		//需要过滤 冒号前面内容的字段，多个用','分隔 ,不传则与显示字段相同
		filter:{
			type: String | Array,
			default: ''
		},
    // 字段最多显示行数
    lines: {
      type: Object,
      default () {
        return {};
      },
    },
    // 转换对象到对应的值
    changeProp: {
      type: Object,
    },
    // 显示的图片字段
    imgKey: {
      type: String,
      default: 'cover_img1'
    },
    // 显示的标签
    labelType: {
      type: String,
      default: ''
    },
    // 显示的标签文字
    labelText: {
      type: String,
      default: ''
    },
    showMask: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number | String,
      default: 1
    },
    // 是否显示自定义的课程标签
    isCustomLabel: {
      type: Boolean,
      default: false
    }
  },
  created () { },
  methods: {
    getLabelType(){
      let { type, is_pay } = this.innerItem;
      if(is_pay === 1){
        return type === 1 ? this.userInfo.is_web_vip ? 'false' : ['','free'][type] : 'false';
      }else{
        return type === 1 && this.userInfo.is_web_vip ? 'false' : ['','free','vip','pay'][type];
      }
    }
  },
}
</script>

<style scoped lang="less">
.course-card {
  .img-box {
    border-radius: 8px;
    transition: transform 0.3s, box-shadow 0.3s;
  }
  /deep/ .hover-show {
    display: none;
  }
  /deep/ .hover-opt {
    opacity: 0;
  }
  &:hover {
    .img-box {
      transform: translateY(-5px) scale(1.05);
      box-shadow: 0 4px 8px 0 rgba(0, 15, 34, 0.08);
    }
    /deep/ .hover-show {
      display: block;
    }
    /deep/ .hover-opt {
      opacity: 1;
    }
    .name {
      color: #1177ff;
    }
  }
}

.tag-left {
  height: 19px;
}
.tag-right {
  height: 19px;
}

.detail-box {
  // padding: 0 16px;
  font-size: 16px;
  color: #333f4e;
  .prop {
    padding-top: 14px;
  }
  .name {
    line-height: 18px;
  }
  .set-line-height{
    line-height: 1.2;
  }
}

.vip-type-tip {
  top: 8px;
  right: 0;
}

.audio-play {
  transition: bottom 0.3s;
  .audio-ico {
    width: 25px;
    height: 25px;
    bottom: 5px;
    left: 8px;
  }
  .audio-bg {
    background: rgba(0, 0, 0, 0.4);
  }
  .audio-imgs {
    width: 64px;
    height: 64px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.mask-box {
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  .icon_play {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.discount {
  border: 1px solid #ff5824;
  border-radius: 4px;
  &-time {
    width: 34px;
    background: linear-gradient(90deg, #ff8726 0%, #ff5724 100%);
    border-radius: 4px 0px 10px 4px;
    color: #fff;
    padding: 4px;
    transform: translateX(-1px);
  }
  &-count {
    color: #ff5d24;
    padding: 4px;
  }
}

.no-discount {
  width: 65px;
  height: 20px;
  line-height: 20px;
  background: url(../../assets/images/card/icon_lj.png) no-repeat;
  color: #fff;
}

.course-price {
  color: #ff2517;
}

.color_999 {
  color: #999fa6;
}

.color_666 {
  color: #666f7a;
}

.opt {
  opacity: 0;
}
</style>